module.exports = __webpack_public_path__ + "img/SlicedRaven.e77d959a.jpg";